import { createBrowserRouter, Outlet } from "react-router-dom";
import { AdminRoute, PublicRoute } from "routes";
import AnnouncementContainer from "../../../modules/announcement/container/AnnouncementContainer";
import AuthContainer from "../../../modules/auth/container/AuthContainer";
import CommunityDetailContainer from "../../../modules/community-detail/container/CommunityDetailContainer";
import MainContainer from "../../../modules/main/container/MainContainer";
import CompanyInfoContainer from "../../../modules/company-info/container/CompanyInfoContainer";
import PolicyContainer from "../../../modules/policy/container/PolicyContainer";
import UserDetailContainer from "../../../modules/user-detail/container/UserDetailContainer";
import RouteLayout from "../components/RouteLayout";
import ServiceContainer from "../../../modules/service/container/ServiceContainer";
import PackageContainer from "../../../modules/package/container/PackageContainer";
import ReportContainer from "../../../modules/report/container/ReportContainer";
import RecordContainer from "../../../modules/record/containers/RecordContainer";
import RecordDetailContainer from "../../../modules/record/containers/RecordDetailContainer";
import CaregiverList from "../../../modules/users/container/CaregiverList";
import ReceiverList from "../../../modules/users/container/ReceiverList";
import GuardianList from "../../../modules/users/container/GuardianList";
import RecordsByReceiverContainer from "../../../modules/record/containers/RecordsByReceiverContainer";
import WeeklyRecortDetailContainer from "../../../modules/record/containers/WeeklyRecordDetailContainer";
import MonthlyReportContainer from "../../../modules/record/containers/MonthlyReportContainer";
import FriendsListContainer from "../../../modules/friends/container/FriendsListContainer";
import CodeContainer from "../../../modules/code/container/CodeContainer";
import AdminUsersContainer from "../../../modules/admin/container/AdminUsersContainer";
import BannerContainer from "../../../modules/banner/container/BannerContainer";
import NetworkListContainer from "../../../modules/network-list/containers/NetworkListContainer";
import NetworkDashboardContainer from "../../../modules/network-dashboard/containers/NetworkDashboardContainer";
import NetworkRankingContainer from "../../../modules/network-ranking/containers/NetworkRankingContainer";
import VideosContainer from "../../../modules/videos/container/VideosContainer";
import WelfareContainer from "../../../modules/welfare/container/WelfareContainer";
import WelfareRegisterContainer from "../../../modules/welfare-register/container/WelfareRegisterContainer";
import IncentiveDashboardContainer from "../../../modules/incentive-dashboard/containers/IncentiveDashboardContainer";
import InfohubContainer from "../../../modules/infohub/container/InfohubContainer";
import ChatHistoryContainer from "../../../modules/chat-history/container/ChatHistoryContainer";
import QuizDocumentContainer from "../../../modules/quiz-document/container/QuizDocumentContainer";
import DocumentDetailContainer from "../../../modules/quiz-document/container/DocumentDetailContainer";
import QuizManagementContainer from "../../../modules/quiz-management/container/QuizManagementContainer";
import QuizDetailContainer from "../../../modules/quiz-management/container/QuizDetailContainer";
import QuizCreateContainer from "../../../modules/quiz-management/container/QuizCreateContainer";
import QuizDifficultyContainer from "../../../modules/quiz-difficulty/container/QuizDifficultyContainer";
import OmniDraftContainer from "../../../modules/omni-draft/container/OmniDraftContainer";
import OmniOriginalPostContainer from "../../../modules/omni-original-post/container/OmniOriginalPostContainer";
import OmniPostContainer from "../../../modules/omni-post/container/OmniPostContainer";

export const PUBLIC_ROUTES: PublicRoute = {
  SIGN_IN: {
    name: "로그인",
    element: <AuthContainer />,
    show: false,
    path: "/",
  },
};

export const ADMIN_ROUTES: AdminRoute = {
  MAIN: {
    name: "통계",
    element: <Outlet />,
    show: true,
    children: [
      {
        name: "대시보드",
        path: "/",
        element: <MainContainer />,
        show: true,
        index: true,
      },
    ],
  },
  USERS: {
    name: "사용자",
    element: <Outlet />,
    show: true,
    path: "/users",
    children: [
      {
        name: "보호사 사용자",
        element: <CaregiverList />,
        show: true,
        path: "/users/caregivers",
      },
      {
        name: "보호자 사용자",
        element: <GuardianList />,
        show: true,
        path: "/users/guardians",
      },
      {
        name: "수급자 사용자",
        element: <ReceiverList />,
        show: true,
        path: "/users/receivers",
      },
      {
        name: "돌봄기록",
        element: <RecordContainer />,
        path: "/users/records",
        show: true,
      },
      {
        name: "월별 기록현황",
        element: <RecordsByReceiverContainer />,
        path: "/users/records/receiver/:receiverId",
        show: false,
      },
    ],
  },
  PRODUCT: {
    name: "결제",
    element: <Outlet />,
    show: true,
    path: "/product",
    children: [
      {
        name: "포인트상품",
        element: <PackageContainer />,
        path: "/product/package",
        show: true,
      },
      {
        name: "부가서비스",
        element: <ServiceContainer />,
        path: "/product/service",
        show: true,
      },
    ],
  },
  DETAIL: {
    name: "상세조회",
    element: <Outlet />,
    show: false,
    path: "/detail",
    children: [
      {
        name: "보호사 프로필",
        element: <UserDetailContainer type="caregivers" />,
        show: false,
        path: "/detail/caregivers/:userId",
      },
      {
        name: "보호자 프로필",
        element: <UserDetailContainer type="guardians" />,
        show: false,
        path: "/detail/guardians/:userId",
      },
      {
        name: "수급자 프로필",
        element: <UserDetailContainer type="receivers" />,
        show: false,
        path: "/detail/receivers/:userId",
      },
      {
        name: "게시물 상세",
        element: <CommunityDetailContainer />,
        show: false,
        path: "/detail/post/:postId",
      },
      {
        name: "일간기록 상세",
        element: <RecordDetailContainer />,
        show: false,
        path: "/detail/record/:recordId",
      },
      {
        name: "주간기록 상세",
        element: <WeeklyRecortDetailContainer />,
        show: false,
        path: "/detail/weekly/:receiverId/:period",
      },
      {
        name: "월간기록 상세",
        element: <MonthlyReportContainer />,
        show: false,
        path: "/detail/monthly/:receiverId/:period",
      },
    ],
  },
  INFORMATION: {
    name: "정보",
    element: <Outlet />,
    show: true,
    path: "/information",
    children: [
      {
        name: "기업정보",
        element: <CompanyInfoContainer />,
        path: "/information/company",
        show: true,
      },
      {
        name: "이용약관",
        element: <PolicyContainer />,
        path: "/information/terms",
        show: true,
      },
      {
        name: "개인정보처리방침",
        element: <PolicyContainer />,
        path: "/information/privacy",
        show: true,
      },
      {
        name: "신고사유",
        element: <ReportContainer />,
        path: "/information/report",
        show: true,
      },
    ],
  },
  CONTENTS: {
    name: "콘텐츠",
    show: true,
    element: <Outlet />,
    path: "/contents",
    children: [
      {
        name: "공지사항",
        element: <AnnouncementContainer />,
        show: true,
        path: "/contents/announcements",
      },
      {
        name: "복지정보",
        element: <WelfareContainer />,
        show: true,
        path: "/contents/welfares",
      },
      {
        name: "복지정보 등록",
        element: <WelfareRegisterContainer />,
        show: false,
        path: "/contents/welfares/register",
      },
      {
        name: "동영상 관리",
        element: <VideosContainer />,
        show: true,
        index: true,
        path: "/contents/videos",
      },
    ],
  },
  ADMIN: {
    name: "시스템",
    show: true,
    element: <Outlet />,
    path: "/admin",
    children: [
      {
        name: "운영자 관리",
        element: <AdminUsersContainer />,
        show: true,
        index: true,
        path: "/admin/users",
      },
      {
        name: "공통코드",
        element: <CodeContainer />,
        show: true,
        index: true,
        path: "/admin/code",
      },
      {
        name: "배너 관리",
        element: <BannerContainer />,
        show: true,
        index: true,
        path: "/admin/banners",
      },
    ],
  },
  NETWORK: {
    name: "추천 네트워크",
    show: true,
    element: <Outlet />,
    isSubAdminAllowed: false,
    path: "/network",
    children: [
      {
        name: "네트워크 대시보드",
        element: <NetworkDashboardContainer />,
        show: true,
        index: true,
        path: "/network/dashboard",
        isSubAdminAllowed: false,
      },
      {
        name: "인센티브 대시보드",
        element: <IncentiveDashboardContainer />,
        show: true,
        index: true,
        path: "/network/incentive/dashboard",
        isSubAdminAllowed: false,
      },
      {
        name: "네트워크 조회",
        element: <NetworkListContainer />,
        show: true,
        index: true,
        path: "/network/list",
        isSubAdminAllowed: false,
      },
      {
        name: "추천인 순위",
        element: <NetworkRankingContainer />,
        show: true,
        index: true,
        path: "/network/ranking",
        isSubAdminAllowed: false,
      },
    ],
  },
  FRIENDS: {
    name: "친구",
    show: true,
    element: <Outlet />,
    isSubAdminAllowed: true,
    children: [
      {
        name: "친구 현황",
        element: <FriendsListContainer />,
        show: true,
        index: true,
        path: "/friends",
        isSubAdminAllowed: true,
      },
    ],
  },
  INFOHUB: {
    name: "지식베이스",
    show: true,
    element: <Outlet />,
    path: "/infohub",
    children: [
      {
        name: "문서관리",
        element: <InfohubContainer />,
        show: true,
        index: true,
        path: "/infohub/documents",
      },
      {
        name: "채팅 내역",
        element: <ChatHistoryContainer />,
        show: true,
        path: "/infohub/chat-history",
      },
    ],
  },
  QUIZ: {
    name: "퀴즈관리",
    show: true,
    element: <Outlet />,
    path: "/quiz",
    children: [
      {
        name: "문서관리",
        element: <QuizDocumentContainer />,
        show: true,
        path: "/quiz/documents",
      },
      {
        name: "문서 상세",
        element: <DocumentDetailContainer />,
        show: false,
        path: "/quiz/documents/:documentId",
      },
      {
        name: "퀴즈관리",
        element: <QuizManagementContainer />,
        show: true,
        path: "/quiz/management",
      },
      {
        name: "퀴즈 생성",
        element: <QuizCreateContainer />,
        show: false,
        path: "/quiz/management/create",
      },
      {
        name: "퀴즈 상세",
        element: <QuizDetailContainer />,
        show: false,
        path: "/quiz/management/:quizId",
      },
      {
        name: "난이도관리",
        element: <QuizDifficultyContainer />,
        show: true,
        path: "/quiz/difficulty",
      },
    ],
  },
  OMNI: {
    name: "마케팅 관리",
    show: true,
    element: <Outlet />,
    isSubAdminAllowed: false,
    path: "/omni",
    children: [
      {
        name: "원문 관리",
        element: <OmniOriginalPostContainer />,
        show: true,
        index: true,
        path: "/omni/article",
        isSubAdminAllowed: false,
      },
      {
        name: "원고 관리",
        element: <OmniDraftContainer />,
        show: true,
        index: true,
        path: "/omni/manuscript",
        isSubAdminAllowed: false,
      },
      {
        name: "원고 상세",
        element: <OmniDraftContainer />,
        show: false,
        path: "/omni/manuscript/:draftId",
        isSubAdminAllowed: false,
      },
      {
        name: "게시글 관리",
        element: <OmniPostContainer />,
        show: true,
        index: true,
        path: "/omni/post",
        isSubAdminAllowed: false,
      },
      {
        name: "게시글 상세",
        element: <OmniPostContainer />,
        show: false,
        path: "/omni/post/:postId",
        isSubAdminAllowed: false,
      },
    ],
  },
};

export const publicRouter = createBrowserRouter(Object.values(PUBLIC_ROUTES));

export const adminRouter = createBrowserRouter([
  {
    element: <RouteLayout />,
    path: "/",
    children: Object.values(ADMIN_ROUTES),
  },
]);
